import styled from 'styled-components'
// import loginBg from '@/assets/imges/login-bg2.png'
import loginBackBg from '@/assets/imges/login-back-bg.jpg'
import cubeImg from '@/assets/imges/cube.png'
// import { DirectLogin } from './direct-login'
// import { ForgetPwd } from './forget-pwd'
import { ResetPwd } from './reset.pwd'
import { useEffect, useMemo, useState } from 'react'
import { Dispaths } from '@/types'
import { useGetLogo } from './util'
import { useFavicon, useTitle } from 'ahooks'
import { getImageSrcFromFilePath } from '../login'
import { t } from '@/i18n'

type LoginStatus = 'direct-login' | 'forget-pwd' | 'reset-pwd' | 'sub-account'

export interface CommonProps {
  setLoginStatus: Dispaths<LoginStatus>
  loginType?: string
}
const bgLoad: React.ReactEventHandler<HTMLImageElement> = e => ((e.target as any).style.opacity = 1)

const Login = () => {
  const [loginStatus, setLoginStatus] = useState<LoginStatus>('direct-login')
  const [active, setActive] = useState('1')
  const [getLogo, logo] = useGetLogo()
  const pageTitle = logo?.page_title || ''
  useTitle(pageTitle)
  useEffect(() => {
    getLogo().catch(_ => {})
  }, [])
  // useEffect(() => {
  //   localStorage.setItem('loginType', active === '1' ? 'main-account' : 'sub-account')
  // }, [active])
  const Logo = useMemo(
    () => getImageSrcFromFilePath(logo?.login_logo_file_path),
    [logo?.login_logo_file_path],
  )
  const LoginBg = useMemo(
    () => getImageSrcFromFilePath(logo?.login_bg_file_path),
    [logo?.login_bg_file_path],
  )
  const Favicon = useMemo(
    () => getImageSrcFromFilePath(logo?.login_icon_file_path),
    [logo?.login_icon_file_path],
  )
  useFavicon(Favicon || 'data:;base64,=')
  return (
    <LoginContainer>
      <BgImg bgImage={LoginBg} onLoad={bgLoad}>
        {Logo !== '' && <img className="logo" alt="..." width={190} src={Logo} />}
        {logo?.on_off === 1 && (
          <p className="copyright">
            {logo?.copyright} {t('版权所有')}
          </p>
        )}
      </BgImg>
      <LoginForm>
        <div className="center">
          <div className="title">{t('重新设置密码')}</div>
          <ResetPwd />
        </div>
        <img src={cubeImg} alt="" style={{ position: 'absolute', right: -20, top: 2 }} />
      </LoginForm>
    </LoginContainer>
  )
}

const LoginContainer = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  background: #dde1ff;
  //display: flex;
  //justify-content: center;
  //align-items: center;
  .logo {
    position: absolute;
    display: inline-block;
    max-width: 190px;
    max-height: 52px;
    height: auto;
    width: auto;
    /* overflow: hidden; */
    z-index: 99;
    margin: 34px 37px;
    object-fit: cover;
  }
  .copyright {
    position: absolute;
    bottom: 50px;
    //left: 15%;
    //transform: translateX(-12%);
    font-size: 12px;
    //font-weight: bolder;
    color: #666666;
    line-height: 18px;
    word-break: break-all;
    word-wrap: break-word;
    width: 97%;
    text-align: center;
  }
`

const BgImg = styled.div<{ bgImage?: string }>`
  position: relative;
  align-items: flex-end;
  flex: 0.6;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  background-image: ${({ bgImage }) => (bgImage ? `url(${bgImage})` : 'none')};
  //height: 100%;
  //width: 100%;
  //min-height: 500px;
  //background-size: contain;
  //position: absolute;
  //top: 0;
  //left: 0;
`

const LoginForm = styled.div`
  position: absolute;
  right: 0px;
  z-index: 1;
  width: 42%;
  height: 100%;
  overflow: hidden;
  //min-height: 484px;
  //background: url(${loginBackBg}) no-repeat;
  background: white;
  border-radius: 24px 0px 0px 24px;
  //box-sizing: border-box;
  //padding: 0 25px 32px 25px;
  .center {
    width: 60%;
    margin: 0 auto;
    margin-top: 40%;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    line-height: 45px;
  }
  .textActive {
    color: #4238c9;
  }
  .textNormal {
    color: #333333;
  }
  .tabs {
    font-weight: bold;
    font-size: 20px;
    display: flex;
    margin-bottom: 40px;
  }
  .logo-box {
    width: 200px;
    height: 140px;
    margin-top: 10px;
    display: flex;
    align-items: center;
  }
`
const Tab = styled.div`
  color: ${props => (props.active ? '#4238C9' : '#333333')};
  display: flex;
  line-height: 30px;
  margin-right: 20px;
  margin-top: 42px;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`

const Line = styled.div`
  width: 20px;
  height: 4px;
  //background: linear-gradient(270deg, #3A5489 0%, #4238C9 100%);
  border-radius: 2px;
  background: ${props => (props.active ? '#4238C9' : '')};
`

export default Login
